var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56302 5.70003C9.42969 5.3667 9.23247 5.10559 8.97135 4.9167C8.71024 4.72781 8.39635 4.63337 8.02969 4.63337C7.82969 4.63337 7.63524 4.66114 7.44635 4.7167C7.25747 4.77225 7.08524 4.87781 6.92969 5.03337L5.96302 4.0667C6.11858 3.91114 6.32969 3.76948 6.59635 3.6417C6.86302 3.51392 7.10747 3.43337 7.32969 3.40003V2.00003H8.66302V3.3667C9.16302 3.4667 9.60191 3.66948 9.97969 3.97503C10.3575 4.28059 10.6408 4.67781 10.8297 5.1667L9.56302 5.70003ZM13.1964 15.0667L10.1297 12C9.96302 12.1667 9.73524 12.3028 9.44635 12.4084C9.15747 12.5139 8.89635 12.5778 8.66302 12.6V14H7.32969V12.5667C6.70747 12.4111 6.18802 12.1278 5.77135 11.7167C5.35469 11.3056 5.05191 10.7889 4.86302 10.1667L6.19635 9.63337C6.32969 10.1 6.55469 10.5 6.87135 10.8334C7.18802 11.1667 7.60747 11.3334 8.12969 11.3334C8.32969 11.3334 8.51302 11.3084 8.67969 11.2584C8.84635 11.2084 9.00747 11.1334 9.16302 11.0334L0.929688 2.80003L1.86302 1.8667L14.1297 14.1334L13.1964 15.0667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIcon);
export default __webpack_public_path__ + "static/media/free-icon.bf5145700fdbd0bb60bd735430392c4f.svg";
export { ForwardRef as ReactComponent };